import { useState } from 'react';
import { NOTES_HEADER_KEYS, NOTES_RECORD_KEYS, customerNoteOptions } from '../../../customer-detail/constants';
import NoteModal from '../../../modals/orderDetails/addNewNote';
import { formatNotesDate } from '../../../order-details/util';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../ui/customAccordian/customAccordian';
import { Table, TableColumnConfig } from '../../../ui/customTable/Table';

const CustomerNotes = ({
  Texts,
  notesTableData,
  className = '',
}: {
  Texts: any;
  notesTableData: any;
  className?: string;
}) => {
  const [value, setValue] = useState('');
  const cartNotesTableHeaders: TableColumnConfig<any>[] = [
    {
      key: NOTES_RECORD_KEYS.AGENT_NAME,
      header: NOTES_HEADER_KEYS.AGENT,
      render: (data) => <div>{data?.split('@')?.[0] ?? 'CSA'}</div>,
    },
    {
      key: NOTES_RECORD_KEYS.TIMESTAMP,
      header: NOTES_HEADER_KEYS.DATE_TIME,
      render: (data) => <div>{formatNotesDate(data)}</div>,
    },
    { key: NOTES_RECORD_KEYS.VALUE, header: NOTES_HEADER_KEYS.NOTES },
  ];

  return (
    <Accordion
      type="single"
      collapsible
      className={'w-full ' + className}
      onValueChange={(value) => {
        setValue(value);
      }}
    >
      <AccordionItem value="openNote">
        <AccordionTrigger className="text-lg font-bold hover:no-underline">
          {' '}
          <p className="mr-auto text-lg font-bold">
            {Texts.customerNotes}
            {value && <>({notesTableData?.length || 0})</>}
          </p>
        </AccordionTrigger>
        <AccordionContent className="relative">
          <section className="mb-2 flex justify-end">
            <NoteModal
              Texts={Texts}
              noteOptions={customerNoteOptions}
              type={'cart'}
              noteNumber={notesTableData?.length ?? 0}
            />
          </section>
          <Table columns={cartNotesTableHeaders} data={notesTableData} />
          {notesTableData && notesTableData?.length === 0 && <p>{Texts.noCustomerNotes}</p>}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default CustomerNotes;
